module.exports = __webpack_public_path__ + "assets/img/block-hover-5089c7e4.png";